import {
  Box,
  Button,
  Grid,
  Typography,
  FormControl,
  Select,
  CircularProgress,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react';

import DeleteIcon from 'common/shared-ui/src/icons/DeleteIcon';
import { getTranslatedText } from 'common/utils/getTranslatedText';

import {
  getContractStagesCommonSettings,
  saveContractStagesCommonSettings,
} from '../../../../../packages/common/api';
import Page from '../../../../../packages/common/shared-ui/src/components/Page';
import ChevronIcon from '../../../../../packages/common/shared-ui/src/icons/ChevronIcon';
import { useTranslation } from '../../../../../packages/common/utils/getLocalString';
import ContractStagesTable from '../ContractStagesTable/ContractStagesTable';

// Original class: errorMessage
const StyledErrorMessage = styled(Grid)(theme => ({
  minHeight: '20px',
}));
// Original class: trackersWrap
const StyledTrackersWrap = styled(Grid)(theme => ({
  display: 'flex',
  backgroundColor: 'white',
  justifyContent: 'space-between',
  alignItems: 'baseline',

  '& $formControlWrap': {
    '& $formControl': {
      '& .MuiChip-deleteIcon': {
        position: 'relative',
        right: 0,
      },
    },
  },

  marginLeft: '0 !important',
  marginTop: '0 !important',

  // width: '48% !important',
  borderRadius: '14px',
}));
// Original class: formControlWrap
const StyledFormControlWrap = styled(Grid)(theme => ({
  padding: '0 !important',

  '& .MuiGrid-item': {
    padding: '0 !important',
  },

  '& .MuiGrid-root': {
    margin: '0 !important',
  },
}));
// Original class: formControl
const StyledFormControl = styled(FormControl)(theme => ({
  marginRight: '0 !important',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'baseline',

  '& .MuiSelect-icon': {
    display: 'none',
  },

  '& .MuiInputBase-formControl': {
    width: '100%',
    height: 'auto !important',
  },

  '& .MuiSelect-select': {
    padding: '3px !important',
  },
}));
// Original class: chips
const StyledChips = styled(Box)(theme => ({
  display: 'flex',
  flexWrap: 'wrap',
  color: '#212346;',
  gap: '5px',

  '& .MuiChip-root': {
    margin: 2,
    backgroundColor: '#FFF',
    border: '1px solid #E4E4EF',
    borderRadius: '14px',
  },

  '& .MuiChip-deleteIcon': {
    height: '10px',
    marginRight: '8px !important',
    marginLeft: '4px !important',
  },
}));
// Original class: optionsGroupMenu
const StyledOptionsGroupMenu = styled(Box)(({ theme }) => ({
  '&.MuiPopover-root': {
    zIndex: 12000,
  },

  '& .MuiPaper-root': {
    borderRadius: theme.spacing(4),
    maxHeight: '40vh',
    overflow: 'auto',
    '& ul': {
      padding: 0,
    },
  },
}));
// Original class: paperDropdown
const StyledPaperDropdown = styled(Paper)(theme => ({
  maxHeight: '300px',
  borderRadius: '0 0 16px 16px',
  borderTop: '1px solid #E4E4EF',
  boxShadow: '0px 5px 10px -8px #A0A1AA66',
  '&::-webkit-scrollbar': {
    width: '2px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#7174AC',
    borderRadius: '5px',
  },
  '& .MuiList-root.MuiMenu-list': {
    padding: '0',
    '& li': {
      fontSize: '14px',
      lineHeight: '20px',
      color: '#212346',
      '&.MuiButtonBase-root.MuiMenuItem-root': {
        '&:hover': {
          backgroundColor: '#DCDFF4',
        },
      },
    },
  },
}));
// Original class: chip
const StyledChip = styled(Chip)(theme => ({
  margin: 2,
  backgroundColor: '#FFF',
  '& .MuiChip-deleteIcon': {
    position: 'static!important',
  },
  '& .MuiChip-label': {
    padding: '8px 0px 8px 8px',
  },
}));
// Original class: menuItemCheckbox
const StyledMenuItemCheckbox = styled(Checkbox)(theme => ({
  color: 'red',

  '& .MuiSvgIcon-root': {
    width: 16,
    height: 16,
    color: '#3448FF',
  },
}));
// Original class: formSingleControl
const StyledFormSingleControl = styled(FormControl)(theme => ({
  marginRight: '0 !important',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'baseline',

  '& .MuiSelect-icon': {
    display: 'none',
  },

  '& .MuiInputBase-formControl': {
    width: '100%',
    height: 'auto !important',
  },
}));
// Original class: groupIcon
const StyledGroupIcon = styled(Box)(theme => ({
  '& .MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall': {
    right: 10,
  },
}));
// Original class: createSelect
const StyledCreateSelect = styled(Select)(theme => ({
  minHeight: '40px',

  '&.MuiInputBase-root.Mui-disabled': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E4E4EF',
    },
    opacity: '70%',
  },

  border: '16px',
}));
// Original class: menuItem
const StyledMenuItem = styled(MenuItem)(theme => ({
  '&.Mui-selected': {
    background: '#DCDFF4 !important',
  },

  '& .MuiTypography-root': {
    textTransform: 'unset',
    color: '#212346',
  },
}));
// Original class: emptyWrap
const StyledEmptyWrap = styled(Grid)(theme => ({
  display: 'none',
  backgroundColor: '#F1F2F8',
  justifyContent: 'space-between',
  alignItems: 'baseline',

  '& $formControlWrap': {
    '& $formControl': {
      '& .MuiChip-deleteIcon': {
        position: 'relative',
        right: 0,
      },
    },
  },

  marginLeft: '0 !important',
  marginTop: '0 !important',

  // width: '48% !important',
  borderRadius: '14px',
}));
const ContractStages = () => {
  const getLocalString = useTranslation();
  const pageTitle = getLocalString('AdminContractStages', 'title');
  const [roles, setRoles] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [trackers, setTrackers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialSettings, setInitialSettings] = useState([]);
  const [initialSelectedSettings, setInitialSelectedSettings] = useState([]);
  const [hasChanged, setHasChanged] = useState(false);
  const [hasCustomerRecords, setHasCustomerRecords] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const getChecked = useCallback(
    (isInitial = false, initialData = []) => {
      let rolesData;
      let customersData;
      let trackersData;
      if (isInitial) {
        rolesData = initialData.roles
          .filter(role => role.isChecked)
          .map(role => Number(role.valueId, 10));
        customersData = Number(
          initialData.customerField.find(customer => customer.isChecked)
            ?.valueId,
          10,
        );
        trackersData = initialData.trackers
          .filter(tracker => tracker.isChecked)
          .map(tracker => Number(tracker.valueId, 10));
      } else {
        rolesData = roles
          .filter(role => role.isChecked)
          .map(role => Number(role.valueId, 10));
        customersData = Number(
          customers.find(customer => customer.isChecked)?.valueId,
          10,
        );
        trackersData = trackers
          .filter(tracker => tracker.isChecked)
          .map(tracker => Number(tracker.valueId, 10));
      }
      const data = {
        trackers: trackersData,
        roles: rolesData,
        customerFieldId: customersData,
      };
      return data;
    },
    [customers, roles, trackers],
  );

  const selectLabel = getLocalString('labels', 'select');
  const fetchContractsData = async () => {
    try {
      setIsLoading(true);

      const response = await getContractStagesCommonSettings();
      setInitialSettings(response.data);
      setRoles(response.data.roles);
      setCustomers(response.data.customerField);
      setTrackers(response.data.trackers);
      setInitialSelectedSettings(getChecked(true, response.data));
      setIsLoading(false);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    fetchContractsData();
  }, []);

  const handleSelectChange = (event, fieldType) => {
    const selectedFieldIds = event.target.value;
    let setFunction;
    if (fieldType === 'roles') {
      setFunction = setRoles;
    } else if (fieldType === 'trackers') {
      setFunction = setTrackers;
    } else if (fieldType === 'customers') {
      setFunction = setCustomers;
    }
    setFunction(prevFilters =>
      prevFilters.map(filter =>
        selectedFieldIds.includes(filter.valueId)
          ? { ...filter, isChecked: true }
          : { ...filter, isChecked: false },
      ),
    );
  };
  const handleRemoveFilter = useCallback((valueId, fieldType) => {
    let setFunction;
    if (fieldType === 'roles') {
      setFunction = setRoles;
    } else if (fieldType === 'trackers') {
      setFunction = setTrackers;
    }
    setFunction(prevFilters => {
      return prevFilters.map(filter =>
        filter.valueId === valueId ? { ...filter, isChecked: false } : filter,
      );
    });
  }, []);

  const handleCancel = useCallback(() => {
    setRoles(initialSettings.roles);
    setCustomers(initialSettings.customerField);
    setTrackers(initialSettings.trackers);
  }, [initialSettings]);

  const handleSave = useCallback(async () => {
    const data = getChecked();
    const hasCustomerChanged =
      data.customerFieldId !== initialSelectedSettings.customerFieldId;
    if (hasCustomerChanged && hasCustomerRecords) {
      setErrorMessage(getLocalString('AdminContractStages', 'error', 'error'));
      return;
    }
    const response = await saveContractStagesCommonSettings(data);
    setInitialSelectedSettings(data);
    setInitialSettings(response.data);
    setHasChanged(false);
  }, [roles, customers, trackers]);
  const handlePageClick = () => {
    if (errorMessage) {
      setErrorMessage('');
    }
  };

  const areObjectsEqual = (obj1, obj2) => {
    if (obj1.customerFieldId !== obj2.customerFieldId) {
      return false;
    }
    const arraysEqual = (arr1, arr2) => {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    };
    return (
      arraysEqual(obj1.roles, obj2.roles) &&
      arraysEqual(obj1.trackers, obj2.trackers)
    );
  };
  useEffect(() => {
    if (!isLoading) {
      const data = getChecked();
      const isEqual = areObjectsEqual(data, initialSelectedSettings);
      setHasChanged(!isEqual);
    }
  }, [roles, customers, trackers, handleSave]);

  return (
    <>
      {!isLoading ? (
        <Page title={pageTitle} width='100%' onClick={handlePageClick}>
          <Grid
            container
            wrap='nowrap'
            direction='row'
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: 2.5,
              marginBottom: 1.5,
            }}
          >
            <Typography variant='h1'>
              {getLocalString(
                'AdminContractStages',
                'labels',
                'contractStages',
              )}
            </Typography>
            <Box
              sx={{
                display: 'flex',
              }}
            >
              <Box
                sx={{
                  marginRight: 2.5,
                }}
              >
                <Button
                  onClick={handleSave}
                  disabled={!hasChanged}
                  type='submit'
                  disableRipple
                  variant='defaultBlueSecondary'
                >
                  {getLocalString('buttons', 'save')}
                </Button>
              </Box>
              <Box>
                <Button
                  type='submit'
                  onClick={handleCancel}
                  disableRipple
                  variant='defaultGreySecondary'
                >
                  {getLocalString('buttons', 'cancel')}
                </Button>
              </Box>
            </Box>
          </Grid>

          <StyledErrorMessage
            item
            sx={{
              marginBottom: 2,
            }}
          >
            {errorMessage && (
              <Typography
                variant='h3'
                sx={{
                  fontWeight: 600,
                  color: '#E03737',
                }}
              >
                {errorMessage}
              </Typography>
            )}
          </StyledErrorMessage>

          <Grid
            container
            wrap='nowrap'
            direction='row'
            sx={{
              justifyContent: 'space-between',
              gap: 5,
              marginBottom: 5,
            }}
          >
            <StyledTrackersWrap
              size={6}
              container
              spacing={5}
              wrap='nowrap'
              sx={{
                padding: 4,
                position: 'relative',
              }}
            >
              <Grid
                sx={{
                  marginRight: 2,
                }}
                size={4}
              >
                <Typography variant='h5'>
                  {getLocalString('AdminContractStages', 'labels', 'trackers')}
                </Typography>
              </Grid>
              <StyledFormControlWrap item xs={8}>
                <StyledFormControl>
                  <Select
                    id='filters'
                    multiple
                    value={trackers
                      .filter(filter => filter.isChecked)
                      .map(filter => filter.valueId)}
                    slots={{}}
                    MenuProps={{
                      slotProps: {
                        paper: {
                          sx: {
                            maxHeight: '300px',
                            borderRadius: '0 0 16px 16px',
                            borderTop: '1px solid #E4E4EF',
                            boxShadow: '0px 5px 10px -8px #A0A1AA66',
                            '&::-webkit-scrollbar': {
                              width: '2px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#7174AC',
                              borderRadius: '5px',
                            },
                            '& .MuiList-root.MuiMenu-list': {
                              padding: '0',
                              '& li': {
                                fontSize: '14px',
                                lineHeight: '20px',
                                color: '#212346',
                                '&.MuiButtonBase-root.MuiMenuItem-root': {
                                  '&:hover': {
                                    backgroundColor: '#DCDFF4',
                                  },
                                },
                              },
                            },
                          },
                        },
                        list: {
                          sx: {
                            padding: 0,
                          },
                        },
                        popover: {
                          sx: {
                            zIndex: 12000,
                          },
                        },
                      },
                    }}
                    onChange={e => handleSelectChange(e, 'trackers')}
                    renderValue={selected => {
                      return (
                        <StyledChips>
                          {selected.map(value => {
                            const filter = trackers.find(
                              filter => filter.valueId === value,
                            );
                            return (
                              <StyledChip
                                key={filter.valueId}
                                label={filter.valueName}
                                clickable
                                deleteIcon={
                                  <DeleteIcon
                                    width={10}
                                    height={10}
                                    viewBox='0 0 10 10'
                                    onMouseDown={event =>
                                      event.stopPropagation()
                                    }
                                  />
                                }
                                onDelete={() =>
                                  handleRemoveFilter(filter.valueId, 'trackers')
                                }
                              />
                            );
                          })}
                        </StyledChips>
                      );
                    }}
                  >
                    {trackers &&
                      trackers
                        .sort((a, b) => b.isChecked - a.isChecked)
                        .map(filter => (
                          <MenuItem key={filter.valueId} value={filter.valueId}>
                            <StyledMenuItemCheckbox
                              checked={filter.isChecked}
                            />
                            <ListItemText primary={filter.valueName} />
                          </MenuItem>
                        ))}
                  </Select>
                </StyledFormControl>
              </StyledFormControlWrap>
            </StyledTrackersWrap>

            <StyledTrackersWrap
              size={6}
              container
              spacing={5}
              wrap='nowrap'
              sx={{
                padding: 4,
                position: 'relative',
              }}
            >
              <Grid
                sx={{
                  marginRight: 2,
                }}
                size={4}
              >
                <Typography variant='h5'>
                  {getLocalString('AdminContractStages', 'labels', 'roles')}
                </Typography>
              </Grid>
              <StyledFormControlWrap item xs={8}>
                <StyledFormControl>
                  <Select
                    id='filters'
                    multiple
                    value={roles
                      .filter(filter => filter.isChecked)
                      .map(filter => filter.valueId)}
                    MenuProps={{
                      slotProps: {
                        paper: {
                          sx: {
                            maxHeight: '300px',
                            borderRadius: '0 0 16px 16px',
                            borderTop: '1px solid #E4E4EF',
                            boxShadow: '0px 5px 10px -8px #A0A1AA66',
                            '&::-webkit-scrollbar': {
                              width: '2px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#7174AC',
                              borderRadius: '5px',
                            },
                            '& .MuiList-root.MuiMenu-list': {
                              padding: '0',
                              '& li': {
                                fontSize: '14px',
                                lineHeight: '20px',
                                color: '#212346',
                                '&.MuiButtonBase-root.MuiMenuItem-root': {
                                  '&:hover': {
                                    backgroundColor: '#DCDFF4',
                                  },
                                },
                              },
                            },
                          },
                        },
                        list: {
                          sx: {
                            padding: 0,
                          },
                        },
                        popover: {
                          sx: {
                            zIndex: 12000,
                          },
                        },
                      },
                    }}
                    onChange={e => handleSelectChange(e, 'roles')}
                    renderValue={selected => {
                      return (
                        <StyledChips>
                          {selected.map(value => {
                            const filter = roles.find(
                              filter => filter.valueId === value,
                            );
                            return (
                              <StyledChip
                                key={filter.valueId}
                                label={filter.valueName}
                                clickable
                                deleteIcon={
                                  <DeleteIcon
                                    width={10}
                                    height={10}
                                    viewBox='0 0 10 10'
                                    onMouseDown={event =>
                                      event.stopPropagation()
                                    }
                                  />
                                }
                                onDelete={() =>
                                  handleRemoveFilter(filter.valueId, 'roles')
                                }
                              />
                            );
                          })}
                        </StyledChips>
                      );
                    }}
                  >
                    {roles &&
                      roles
                        .sort((a, b) => b.isChecked - a.isChecked)
                        .map(filter => (
                          <MenuItem key={filter.valueId} value={filter.valueId}>
                            <StyledMenuItemCheckbox
                              checked={filter.isChecked}
                            />
                            <ListItemText primary={filter.valueName} />
                          </MenuItem>
                        ))}
                  </Select>
                </StyledFormControl>
              </StyledFormControlWrap>
            </StyledTrackersWrap>
          </Grid>

          <Grid
            container
            wrap='nowrap'
            direction='row'
            sx={{
              justifyContent: 'space-between',
              gap: 5,
              marginBottom: 5,
            }}
          >
            <StyledTrackersWrap
              size={6}
              container
              spacing={5}
              wrap='nowrap'
              sx={{
                padding: 4,
                position: 'relative',
              }}
            >
              <Grid
                sx={{
                  marginRight: 2,
                }}
                size={4}
              >
                <Typography variant='h5'>
                  {getLocalString('AdminContractStages', 'labels', 'customers')}
                </Typography>
              </Grid>
              <StyledFormControlWrap size={'grow'}>
                <StyledFormSingleControl>
                  <StyledCreateSelect
                    variant='outlined'
                    IconComponent={() => (
                      <StyledGroupIcon>
                        <ChevronIcon
                          direction='down'
                          fontSize='small'
                          viewBox='0 0 24 24'
                        />
                      </StyledGroupIcon>
                    )}
                    value={
                      customers.find(setting => setting.isChecked)?.valueId ||
                      '0'
                    }
                    defaultValue={0}
                    onChange={e => handleSelectChange(e, 'customers')}
                    MenuProps={{
                      slotProps: {
                        paper: {
                          sx: {
                            maxHeight: '300px',
                            borderRadius: '0 0 16px 16px',
                            borderTop: '1px solid #E4E4EF',
                            boxShadow: '0px 5px 10px -8px #A0A1AA66',
                            '&::-webkit-scrollbar': {
                              width: '2px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                              backgroundColor: '#7174AC',
                              borderRadius: '5px',
                            },
                            '& .MuiList-root.MuiMenu-list': {
                              padding: '0',
                              '& li': {
                                fontSize: '14px',
                                lineHeight: '20px',
                                color: '#212346',
                                '&.MuiButtonBase-root.MuiMenuItem-root': {
                                  '&:hover': {
                                    backgroundColor: '#DCDFF4',
                                  },
                                },
                              },
                            },
                          },
                        },
                        list: {
                          sx: {
                            padding: 0,
                          },
                        },
                        popover: {
                          sx: {
                            zIndex: 12000,
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem disabled value={0} key={0}>
                      <Typography
                        variant='h4'
                        sx={{
                          color: '#212346',
                        }}
                      >
                        {selectLabel}
                      </Typography>
                    </MenuItem>
                    {customers
                      .sort((a, b) => b.isChecked - a.isChecked)
                      .map(setting => (
                        <StyledMenuItem
                          key={setting.valueId}
                          value={setting.valueId}
                        >
                          <Typography
                            variant='h4'
                            sx={{
                              color: '#212346',
                            }}
                          >
                            {setting.valueName}
                          </Typography>
                        </StyledMenuItem>
                      ))}
                  </StyledCreateSelect>
                </StyledFormSingleControl>
              </StyledFormControlWrap>
            </StyledTrackersWrap>
            <StyledEmptyWrap
              container
              spacing={5}
              wrap='nowrap'
              sx={{
                padding: 4,
                position: 'relative',
              }}
            ></StyledEmptyWrap>
          </Grid>
          <ContractStagesTable
            setHasCustomerRecords={setHasCustomerRecords}
            setErrorMessage={setErrorMessage}
          />
        </Page>
      ) : (
        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100vh',
          }}
        >
          <CircularProgress color='secondary' />
        </Grid>
      )}
    </>
  );
};

export default ContractStages;
